import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Card,
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
} from "react-bootstrap";
import {
  updateAbsenteeismReport,
  postAbsenteeismReport,
  postAbsenteeismExcel,
  resetAbsenteeismReport,
} from "./AbsenteeismSlice";
import { useDispatch, useSelector } from "react-redux";
import { triggerBase64Download } from "common-base64-downloader-react";
import SideMenu from "../../UI/SIdeMenu";
import Navibar from "../../UI/Navibar";
import Footer from "../../UI/Footer";

function AbsenteeismComponent() {
  const dispatch = useDispatch();
  const { absenteeismReport } = useSelector((state) => state.AbsenteeismSlice);
  const [table, setTable] = useState([]);
  const { fromdate, todate } = absenteeismReport;

  const handleChangeForm = (e) => {
    const entity = { ...absenteeismReport, [e.target.name]: e.target.value };
    dispatch(updateAbsenteeismReport(entity));
  };

  const handleClickSearch = () => {
    const entity = { ...absenteeismReport };
    // console.log(entity);
    dispatch(postAbsenteeismReport(entity)).then((res) => {
      console.log(res);
      console.log(res.payload);
      res.payload.forEach((res) => {
        console.log(res);
        const dateString = res.cdate.split("T")[0];
        res.cdate = dateString;
      });
      setTable(res.payload);
    });
  };

  const handleExportExcel = () => {
    const entity = { ...absenteeismReport };
    dispatch(postAbsenteeismExcel(entity)).then((res) => {
      console.log(res);
      console.log(res.payload);
      const base64EXCEL =
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
        res.payload;
      triggerBase64Download(
        base64EXCEL,
        "absenteeism_report" + "_" + new Date().toISOString().slice(0, 10)
      );
    });
  };

  const handleBack = () => {
    const entity = { ...absenteeismReport };
    dispatch(resetAbsenteeismReport(entity));
    setTable([]);
  };

  return (
    <div className="Div">
      <Container fluid>
      <Row>
          <Col xs={12} className="fixed-top">
            <Navibar />
          </Col>
        </Row>
        <Row>
          <Col xs={2} id="sidebar-wrapper" className="sidemenu"  style={{ marginTop: "50px" }}>
            <SideMenu />
          </Col>
          <Col>
            <Card className="content">
              <Form>
                <Container>
                  <Row className="mb-3 mt-3">
                    <Col md={12}>
                      <h4>ABSENTEEISM REPORT</h4>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Label>FROM DATE:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Form.Control
                        type="date"
                        name="fromdate"
                        value={fromdate}
                        onChange={handleChangeForm}
                        placeholder="dd/mm/yy"
                      ></Form.Control>
                    </Col>
                    <Col md={3}>
                      <Form.Label>TO DATE:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Form.Control
                        type="date"
                        name="todate"
                        value={todate}
                        onChange={handleChangeForm}
                        placeholder="dd/mm/yy"
                      ></Form.Control>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center mb-3">
                    <Col xs="auto" md={12}>
                      <Form.Group>
                        <Button
                          type="button"
                          bg="dark"
                          variant="dark"
                          onClick={handleClickSearch}
                        >
                          SEARCH
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Card>
                    <Table striped bordered hover size="sm">
                      <thead>
                        <tr>
                          <th>NO.</th>
                          <th>DATE</th>
                          <th>USER ID</th>
                          <th>NAME</th>
                          <th>DEPARTMENT</th>
                          <th>SUPERVISOR</th>
                        </tr>
                      </thead>
                      <tbody>
                        {table.map(({ cdate, person, department }, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{cdate}</td>
                            <td>{person.personnel_id}</td>
                            <td>{person.fullname}</td>
                            <td>{department.description}</td>
                            <td>{person?.superior?.fullname}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card>
                  <Row className="mt-3 mb-3">
                    <Col md={1}>
                      <Button
                        type="button"
                        bg="dark"
                        variant="dark"
                        onClick={handleBack}
                      >
                        Back
                      </Button>
                    </Col>
                    <Col md={9}></Col>
                    <Col md={2}>
                      <Button
                        type="button"
                        bg="dark"
                        variant="dark"
                        onClick={() => handleExportExcel()}
                      >
                        Export Excel Report
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer />
    </div>
  );
}

export default AbsenteeismComponent;
